import { Stack } from '@mui/material';
import { Button } from '@tempo-io/sui-button';

import { useSwimlaneEventPublisher } from '../../api/useSwimlaneEventPublisher';

import { NoItemsIcon } from './icons/NoItemsIcon';
import {
  FooterTypography,
  StyledBox,
  StyledDiv,
  StyledDivider,
  SubtitleTypography,
  TitleTypography,
} from './StyledComponents';

export function NoItems() {
  const publishEvent = useSwimlaneEventPublisher();
  return (
    <StyledDiv>
      <StyledBox>
        <NoItemsIcon />
        <TitleTypography>Blank Space, Big Plans</TitleTypography>
        <SubtitleTypography>
          Get started by adding an item or syncing in a few you've already made.
        </SubtitleTypography>
        <Stack
          direction="row"
          sx={{
            gap: 6,
          }}
        >
          <Button
            onClick={() => publishEvent('emptyStateButtonClicked', { action: 'create-item' })}
          >
            Create Your First Item
          </Button>
          <Button
            variant="outline"
            onClick={() => publishEvent('emptyStateButtonClicked', { action: 'sync-data' })}
          >
            Sync Your Data
          </Button>
        </Stack>
        <StyledDivider variant="middle" />
        <FooterTypography>
          Need more guidance?
          <br />
          <a
            href="https://help.tempo.io/roadmaps/latest/getting-started-in-the-swimlane-beta"
            target="_blank"
            rel="noreferrer"
          >
            Visit the Tempo Help Center
          </a>
        </FooterTypography>
      </StyledBox>
    </StyledDiv>
  );
}
